import React from "react";
import { IPetsyPProps } from "./PetsyP.types";
import {
  useFlowData
} from "@adaptis/flow-components";
import { tips } from "../PopupTips/tips";
import _ from "../../imports/lodash-imports";
import "./PetsyP.scss";

export default function PetsyP(props: IPetsyPProps) {
  const { getData } = useFlowData();
  const [content, setContent] = React.useState<string>("");

  React.useEffect(() => {
    const petAgeOnStartDatePolicy = getData("petAgeOnStartDatePolicy");

    // 1094 = 2years + 364 days (1 year = 365 days)
    // if (petAgeOnStartDatePolicy > 1094 && props.contentOver3year) {
    if (petAgeOnStartDatePolicy > 1095 && props.contentOver3year) {
      setContent(props.contentOver3year || "");
    } else {
      setContent(props.content || "");
    }
  }, []);

  return (
    <p className={props.className}>
      {content}
    </p>
  );
}
